import { Injectable } from "@fiqas/angular-utils";
import { FIQAssist } from "../app";
import { IDisposable } from "../interfaces/general";
import { ValidationResult } from "../models/base";

export interface LogListener {
    onDebug(message: LogMessage): void;
    onInfo(message: LogMessage): void;
    onWarning(message: LogMessage): void;
    onError(message: LogMessage): void;
    onAny(message: LogMessage): void;
}

export interface LogMessage {
    source: string;
    error?: Error | ValidationResult;
    message: string;
    level: logLevel;
}

export type logLevel = 'debug' | 'info' | 'warning' | 'error';

@Injectable({
    module: FIQAssist,
    selector: LogService.selector
})
export class LogService {
    public static selector = "logService";
    constructor() {

    }

    private listeners: LogListener[] = [];
    public registerListner(listner: LogListener): IDisposable {
        this.listeners.push(listner);
        return () => this.listeners = this.listeners.filter(l => l != listner);
    }

    public debug(source:string, message:string, error?:Error) {
        this.listeners.forEach(l=>{
            var msg:LogMessage = {
                source:source,
                message:message,
                error:error,
                level:'debug'
            }
            l.onDebug(msg);
            l.onAny(msg);
        })
    }

    public info(source:string, message:string, error?:Error) {
        this.listeners.forEach(l=>{
            var msg:LogMessage = {
                source:source,
                message:message,
                error:error,
                level:'info'
            }
            l.onInfo(msg);
            l.onAny(msg);
        })
    }

    public warning(source:string, message:string, error?:Error) {
        this.listeners.forEach(l=>{
            var msg:LogMessage = {
                source:source,
                message:message,
                error:error,
                level:'warning'
            }
            l.onWarning(msg);
            l.onAny(msg);
        })
    }

    public error(source:string, message:string, error?:Error) {
        this.listeners.forEach(l=>{
            var msg:LogMessage = {
                source:source,
                message:message,
                error:error,
                level:'error'
            }
            l.onError(msg);
            l.onAny(msg);
        })
    }
}
